module.exports = __webpack_public_path__ + "img/benefit.8d0ae3b8.png";